import React, { useRef, useEffect, useState } from "react";
import "../../styles/whyChooseUs2.css";

const whyContent = {
  title: "Why Choose Us",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit Asperiores dolores sed et. Tenetur quia eos. Autem tempore quibusdam vel necessitatibus optio ad corporis.",
  linkText: "Learn More",
  iconBoxes: [
    {
      icon: "bi bi-box2",
      title: "High Quality Material",
      desc: "Kami menggunakan bahan baku terbaik yang bisa disesuaikan dengan budget dan kebutuhan anda yang didukung oleh supplier yang telah terjamin mutu dan kualitasnya.",
    },
    {
      icon: "bi bi-people",
      title: "Professional Employe",
      desc: "SDM yang unggul dan handal dibidangnya menjadi senjata utama kami guna menopang proses produksi yang stabil dan berorientasi pada hasil yang maksimal untuk menciptakan produk berkualitas.",
    },
    {
      icon: "bi bi-kanban-fill",
      title: "The Biggest Production Capacity",
      desc: "Kami mempunyai kapasitas produksi mencapai 50.000 pcs/bulan sehingga anda tidak perlu khawatir tentang slot produksi untuk orderan Anda. Berapapun kuantiti yang anda butuhkan kami siap untuk mengerjakan dengan semaksimal mungkin.",
    },
    {
      icon: "bi bi-award",
      title: "Guaranteed Product",
      desc: "Kami memberikan garansi untuk setiap produk yang kami ciptakan guna menjamin kepuasan setiap pelanggan.",
    },
    {
      icon: "bi bi-shield-check",
      title: "Quality Control",
      desc: "Pengecekan yang ketat disetiap tahapan produksi mulai dari Pemilihan bahan baku, proses cutting, proses sablon, proses sewing dan sebelum produk difinishing, menjamin kualitas yang terukur dan stabil pada setiap produk sebelum diterima oleh pelanggan.",
    },
    {
      icon: "bi bi-truck",
      title: "Ontime delivery",
      desc: "Penjadwalan produksi yang tersistem menjamin ketepatan waktu pada setiap pengiriman menjadi priositas utama kami demi menjaga klepercayaan dan kenyamanan setiap pelanggan.",
    },
    {
      icon: "bi bi-map",
      title: "Pickup Order Service",
      desc: "Jika anda tidak punya waktu untuk order secara langsung, kami dapat memberikan fasilitas untuk dapat datang ke tempat anda dengan syarat dan ketentuan yang berlaku.",
    },
    {
      icon: "bi bi-palette",
      title: "Free Design Service",
      desc: "Kami berikan fasilitas berupa free konsultasi dan desain grafis untuk setiap customer guna mendapatkan desain yang eksklusif untuk setiap produk pesanan anda.",
    },
  ],
};

const WhyChooseUs2 = () => {
  const containerRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const updateButtons = () => {
    const el = containerRef.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 5);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };

  useEffect(() => {
    updateButtons();
    const el = containerRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    return () => {
      el.removeEventListener("scroll", updateButtons);
      window.removeEventListener("resize", updateButtons);
    };
  }, []);

  const scrollByPage = (dir = 1) => {
    const el = containerRef.current;
    if (!el) return;
    const amount = Math.round(el.clientWidth * 0.75);
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <section id="why-us" className="why-us section light-background">
      <div className="container-fluid px-3">
        {/* Header */}
        <div className="section-header" data-aos="fade-up" data-aos-delay="100">
          <h2>{whyContent.title}</h2>
          {/* <p>{whyContent.description}</p> */}
        </div>

        {/* Horizontal list with nav buttons */}
        <div className="why-list-wrap">
          <button
            className={`why-list__nav why-list__nav--prev ${canLeft ? "" : "why-list__nav--disabled"}`}
            aria-hidden={!canLeft}
            onClick={() => scrollByPage(-1)}
            aria-label="Scroll left"
          >
            <i className="bi bi-chevron-left" />
          </button>

          <div
            className="why-list"
            ref={containerRef}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="why-list__inner">
              {whyContent.iconBoxes.map((box, idx) => (
                <div className="why-list__item" key={idx}>
                  <div className="why-card">
                    <i className={box.icon}></i>
                    <h4>{box.title}</h4>
                    <p>{box.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            className={`why-list__nav why-list__nav--next ${canRight ? "" : "why-list__nav--disabled"}`}
            aria-hidden={!canRight}
            onClick={() => scrollByPage(1)}
            aria-label="Scroll right"
          >
            <i className="bi bi-chevron-right" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs2;
